import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { User } from '../../_models/user';
import { ProductAttribute } from '../../_models/productAttribute';
import { Subject } from 'rxjs';
import { Register } from '../../_models/register';
import { Product } from '../../_models/product';
import { KitComponent } from '../../_models/kitComponent';
import { AlertService } from '../../_services/alert.service';
import { Location } from '@angular/common';
import * as _ from "lodash";

@Component({
  selector: 'app-create-inventory',
  templateUrl: './create-inventory.component.html',
  styleUrls: ['./create-inventory.component.css']
})
export class CreateInventoryComponent implements OnInit {
  accountOwners: any;
  tabClicked = "basicProductInformation";
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  statusText8: string = "";
  productName: string;
  productType: string;
  barCode: string;
  rackLocation: string;
  weight: string;
  sku: string;
  binLocation: string;
  hsnCode: string;
  dimensions: string;
  length: string;
  width: string;
  height: string;
  minQuantity: string;
  accountOwner: string;
  accountId: any;
  accountOwnerError: string;
  uploadImage: string;
  errorMessage: string;
  productImage: string = "/assets/images/default-product.png";
  imageUrl: string;
  imageUrlError: string;
  price: string;
  taxRate: string;
  storeSku: string;

  constructor(private alertService: AlertService, private location: Location, private http: HttpClient, private router: Router, private api: ApiIntegration, private g: Globals, public user: User, public register: Register) {
    this.g.page = "Create Product";
    if (this.user.role == 'ROLE_ADMIN') {
      this.api.getAccountOwners("1", "ACTIVE").subscribe((data: any) => {
        this.accountOwners = data.getAccountOwnersResponses;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  goBack() {
    this.location.back();
  }

  customSearchAccountOwner(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.ownerName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }

  tabChange(tab) {
    this.tabClicked = tab
    this.imageUrlError = "";
  }

  ngOnInit(): void {
  }

  typeProduct() {
    this.statusText1 = "";
    if (this.productName == '' || this.productName === null || this.productName === undefined || this.productName === 'undefined') {
      this.statusText1 = 'Please enter Product Name';
    }
  }

  typeStoreSku() {
    this.statusText2 = "";
    if (this.storeSku == '' || this.storeSku === null || this.storeSku === undefined || this.storeSku === 'undefined') {
      this.statusText2 = 'Please enter store SKU';
    } else if (this.storeSku.length <= 3) {
      this.statusText2 = 'Store SKU must contain atleast 3-50 characters';
    }
  }

  skuValue() {
    this.sku = 'SFT' + this.storeSku + this.user.accountOwnerId;
  }

  typeHsn() {
    this.statusText6 = "";
    if (this.hsnCode == '' || this.hsnCode === null || this.hsnCode === undefined || this.hsnCode === 'undefined') {
      this.statusText6 = 'Please enter HSN Code';
    }
  }

  /*

    typeMinQuantity() {
      this.statusText8 = "";
      if (this.minQuantity == '' || this.minQuantity === null || this.minQuantity === undefined || this.minQuantity === 'undefined') {
        this.statusText8 = 'Please enter Min Quantity';
      }
    }
   */

  accountOwnerBlur() {
    if (this.user.role == "ACCOUNT_OWNER" || this.user.role == "DEMO_ACCOUNT") {
      this.accountId = this.user.accountOwnerId;
    } else {
      this.accountId = this.accountOwner;
    }
    this.accountOwnerError = "";
    if (!this.accountId && this.user.role === "ROLE_ADMIN") {
      this.accountOwnerError = 'Please enter accountOwner';
    }
  }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.errorMessage = "";
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  submitProduct() {
    if (this.user.role == "ACCOUNT_OWNER" || this.user.role == "DEMO_ACCOUNT") {
      this.accountId = this.user.accountOwnerId;
    } else {
      this.accountId = this.accountOwner;
    }

    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText6 = "";
    this.statusText8 = "";
    this.imageUrlError = "";
    this.accountOwnerError = "";
    if (this.productName == '' || this.productName === null || this.productName === undefined || this.productName === 'undefined') {
      this.statusText1 = 'Please enter Product Name';
    }
    if (!this.accountId && this.user.role === "ROLE_ADMIN") {
      this.accountOwnerError = 'Please select accountOwner';
    }/*
    if (this.minQuantity == '' || this.minQuantity === null || this.minQuantity === undefined || this.minQuantity === 'undefined') {
      this.statusText8 = 'Please enter Min Quantity';
    } */
    if (this.hsnCode == '' || this.hsnCode === null || this.hsnCode === undefined || this.hsnCode === 'undefined') {
      this.statusText6 = 'Please enter HSN Code';
    }
    if (this.storeSku == '' || this.storeSku === null || this.storeSku === undefined || this.storeSku === 'undefined') {
      this.statusText2 = 'Please enter Store SKU';
    } else if (this.storeSku.length <= 3) {
      this.statusText2 = 'Store SKU must contain atleast 3-50 characters';
    }
    if (!this.imageUrl && this.productType === 'Label') {
      this.imageUrlError = 'Please select Image';
    }
    if (this.imageUrlError != "" || this.statusText1 != "" || this.statusText2 != "" || this.statusText6 != "" || this.accountOwnerError != "") {
      this.g.loaderDisplay = "";
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createProduct', {
      "accountOwnerId": this.accountId,
      "organizationId": 1,
      "barCode": this.barCode,
      "binLocation": this.binLocation,
      "minQuantity": 0,
      "dimensions": this.length + "*" + this.width + "*" + this.height,
      "imageUrl": this.imageUrl,
      "productName": this.productName,
      "productType": "REGULAR",
      "sku": this.sku,
      "price": this.price,
      "taxRate": this.taxRate,
      "status": "ACTIVE",
      "weight": this.weight,
      "rackLocation": this.rackLocation,
      "hsnCode": this.hsnCode
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Product', 'Created Successfully');
          this.goBack();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
